<template>
  <div class="register-root">
    <div class="register-card">
      <h2 class="register-title">用户注册</h2>
      <form class="register-form" @submit.prevent="onSubmit">
        <div class="form-group">
          <label>手机号 <span class="required">*</span></label>
          <input v-model="form.phone" type="tel" placeholder="请输入手机号" required />
        </div>
        <div class="form-group">
          <label>密码 <span class="required">*</span></label>
          <input v-model="form.password" type="password" placeholder="请输入密码" required />
        </div>
        <div class="form-group">
          <label>验证码 <span class="required">*</span></label>
          <div class="verify-input-group">
            <input v-model="form.code" type="text" placeholder="请输入验证码" required />
            <button type="button" class="ghost-btn" @click="onGetCode" :disabled="codeTimer > 0">
              {{ codeTimer > 0 ? codeTimer + '秒后重试' : '获取验证码' }}
            </button>
          </div>
        </div>
        <div class="form-group">
          <label>邀请码</label>
          <input 
            v-model="form.invitationCode" 
            type="text" 
            :placeholder="inviteFromUrl ? '邀请码已自动填写' : '请输入邀请码（选填）'" 
            :readonly="!!inviteFromUrl"
            :class="{ 'readonly-input': inviteFromUrl }"
          />
        </div>
        <div class="form-group">
          <label>您是从哪个渠道了解到聚宝铺? <span class="required">*</span></label>
          <div class="checkbox-group">
            <div class="checkbox-row">
              <div class="checkbox-item">
                <input 
                  type="checkbox" 
                  id="xiaohongshu" 
                  v-model="form.knowChannels.xiaohongshu"
                  @change="updateIsKnow"
                />
                <label for="xiaohongshu">小红书</label>
              </div>
              <div class="checkbox-item">
                <input 
                  type="checkbox" 
                  id="douyin" 
                  v-model="form.knowChannels.douyin"
                  @change="updateIsKnow"
                />
                <label for="douyin">抖音</label>
              </div>
            </div>
            <div class="checkbox-row">
              <div class="checkbox-item">
                <input 
                  type="checkbox" 
                  id="friend" 
                  v-model="form.knowChannels.friend"
                  @change="updateIsKnow"
                />
                <label for="friend">朋友直接介绍</label>
              </div>
              <div class="checkbox-item">
                <input 
                  type="checkbox" 
                  id="moments" 
                  v-model="form.knowChannels.moments"
                  @change="updateIsKnow"
                />
                <label for="moments">朋友圈间接了解</label>
              </div>
            </div>
            <div class="checkbox-row">
              <div class="checkbox-item">
                <input 
                  type="checkbox" 
                  id="other" 
                  v-model="form.knowChannels.other"
                  @change="updateIsKnow"
                />
                <label for="other">其他</label>
                <input 
                  v-if="form.knowChannels.other"
                  v-model="form.otherChannel" 
                  type="text" 
                  placeholder="请输入其他渠道" 
                  class="other-input"
                  @input="updateIsKnow"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="form-group agree-group">
          <input v-model="form.agree" type="checkbox" id="agree" required />
          <label for="agree" class="agree-label">
            我已阅读并同意 <a href="#" @click.prevent="openTerms">《服务条款》</a> 和 <a href="#" @click.prevent="openPrivacyPolicy">《隐私政策》</a>
          </label>
        </div>
        <button class="main-btn" type="submit">注册</button>
        <p v-if="submitted" class="success">注册成功！请查收短信或邮件激活账号。</p>
      </form>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { register, sendCode } from '../api/admin'

const route = useRoute()
const router = useRouter()
const form = ref({ 
  phone: '', 
  password: '', 
  code: '', 
  invitationCode: '', 
  agree: false,
  knowChannels: {
    xiaohongshu: false,
    douyin: false,
    friend: false,
    moments: false,
    other: false
  },
  otherChannel: '',
  isKnow: '',
  tenantId: ''
})
const submitted = ref(false)
const loading = ref(false)
const codeLoading = ref(false)
const codeTimer = ref(0)
const inviteFromUrl = ref('')
const tenantId = ref('')
let timerInterval = null

onMounted(() => {
  document.title = '聚宝铺-用户注册'
  // 支持 invitationCode 或 invite 两种参数
  const inviteParam = route.query.invitationCode || route.query.invite
  const tenantId = route.query.tenantId
  if (inviteParam) {
    // 保存到localStorage
    localStorage.setItem('invitationCode', inviteParam)
    inviteFromUrl.value = inviteParam
    form.value.invitationCode = inviteParam
    form.value.tenantId = inviteParam
  } else {
    // 没有URL参数则查localStorage
    const localInvite = localStorage.getItem('invitationCode')
    if (localInvite) {
      inviteFromUrl.value = localInvite
      form.value.invitationCode = localInvite
    } else {
      inviteFromUrl.value = ''
      form.value.invitationCode = ''
    }
  }
  if(tenantId){
    localStorage.setItem('tenantId', tenantId)
    form.value.tenantId = tenantId
  } else {
    const tenantId1 = localStorage.getItem('tenantId')
    if (tenantId1) {
      form.value.tenantId = tenantId1
    } else {
      form.value.tenantId = ''
    }
  }
})

async function onSubmit() {
  loading.value = true
  try {
    const res = await register(form.value)
    if (res.code === 200) {
      submitted.value = true
      alert(res.data || '注册成功！')
      // Redirect to homepage after registration
      window.location.href = '/'
    } else {
      alert(res.message || res.data || '注册失败')
    }
  } catch (e) {
    console.log(e)
  } finally {
    loading.value = false
  }
}

function openTerms() {
  router.push('/terms')
}

function openPrivacyPolicy() {
  router.push('/privacy')
}

function updateIsKnow() {
  const selectedChannels = []
  
  if (form.value.knowChannels.xiaohongshu) {
    selectedChannels.push('小红书')
  }
  if (form.value.knowChannels.douyin) {
    selectedChannels.push('抖音')
  }
  if (form.value.knowChannels.friend) {
    selectedChannels.push('朋友直接介绍')
  }
  if (form.value.knowChannels.moments) {
    selectedChannels.push('朋友圈间接了解')
  }
  if (form.value.knowChannels.other) {
    const otherText = form.value.otherChannel.trim()
    if (otherText) {
      selectedChannels.push(`其他（${otherText}）`)
    } else {
      selectedChannels.push('其他')
    }
  }
  
  form.value.isKnow = selectedChannels.join('、')
}

async function onGetCode() {
  if (!form.value.phone) {
    alert('请先输入手机号')
    return
  }
  if (codeTimer.value > 0) return
  codeLoading.value = true
  try {
    const res = await sendCode(form.value.phone)
    if (res.code === 200) {
      alert('验证码已发送')
      codeTimer.value = 60
      timerInterval = setInterval(() => {
        if (codeTimer.value > 0) {
          codeTimer.value--
        } else {
          clearInterval(timerInterval)
          timerInterval = null
        }
      }, 1000)
    } else {
      alert(res.data || res.msg || res.message || '发送失败')
    }
  } catch (e) {
    console.log(e)
  } finally {
    codeLoading.value = false
  }
}
</script>

<style scoped>
.register-root {
  min-height: 100vh;
  background: #f7faff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0 0 0;
}
.register-card {
  background: #fff;
  border-radius: 24px;
  box-shadow: 0 4px 24px #4ba3fa22;
  padding: 48px 40px 36px 40px;
  max-width: 420px;
  width: 100%;
  color: #222;
}
.register-title {
  color: #2979ff;
  font-size: 2rem;
  text-align: center;
  margin-bottom: 32px;
  letter-spacing: 2px;
}
.register-form {
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
  position: relative;
}
.form-group label {
  color: #2979ff;
  font-size: 1rem;
  margin-bottom: 2px;
}
.required {
  color: #4ba3fa;
  font-size: 1em;
}
.register-form input[type="text"],
.register-form input[type="tel"],
.register-form input[type="password"] {
  background: #f7faff;
  border: 1.5px solid #4ba3fa;
  border-radius: 16px;
  color: #222;
  padding: 12px 14px;
  font-size: 1rem;
  outline: none;
  transition: border 0.2s, box-shadow 0.2s;
  width: 100%;
  box-sizing: border-box;
  box-shadow: 0 1px 4px #4ba3fa11;
}
.register-form input:focus {
  border: 2px solid #2979ff;
  box-shadow: 0 0 0 2px #4ba3fa33;
}
.readonly-input {
  background: #eaf3fb !important;
  border-color: #bcdcff !important;
  color: #a0a4ad !important;
  cursor: not-allowed;
}
.readonly-input:focus {
  border-color: #bcdcff !important;
  box-shadow: none !important;
}
.readonly-input::placeholder {
  color: #a0a4ad99 !important;
}
.checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.checkbox-row {
  display: flex;
  gap: 24px;
}
.checkbox-item {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
}
.checkbox-item input[type="checkbox"] {
  width: 18px;
  height: 18px;
  accent-color: #2979ff;
  cursor: pointer;
}
.checkbox-item label {
  color: #222;
  font-size: 0.95rem;
  cursor: pointer;
  user-select: none;
  margin: 0;
}
.other-input {
  margin-left: 8px;
  flex: 1;
  max-width: 340px;
  background: #f7faff;
  border: 1.5px solid #4ba3fa;
  border-radius: 8px;
  color: #222;
  padding: 6px 8px;
  font-size: 0.9rem;
  outline: none;
  transition: border 0.2s, box-shadow 0.2s;
  box-shadow: 0 1px 4px #4ba3fa11;
}
.other-input:focus {
  border: 2px solid #2979ff;
  box-shadow: 0 0 0 2px #4ba3fa33;
}
.verify-input-group {
  display: flex;
  gap: 12px;
  align-items: stretch;
}
.verify-input-group input {
  flex: 1;
}
.ghost-btn {
  background: #fff;
  color: #2979ff;
  border: 1.5px solid #4ba3fa;
  border-radius: 16px;
  padding: 12px 16px;
  font-size: 0.95rem;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
  white-space: nowrap;
  box-shadow: 0 2px 8px #4ba3fa33;
  height: auto;
  box-sizing: border-box;
}
.ghost-btn:hover {
  background: #eaf3fb;
  color: #2979ff;
}
.ghost-btn[disabled] {
  opacity: 0.6;
  cursor: not-allowed;
  background: #eaf3fb;
  color: #bcdcff;
  border-color: #bcdcff;
}
.agree-group {
  flex-direction: row;
  align-items: center;
  gap: 8px;
  margin-top: 4px;
}
.agree-label {
  color: #2979ff;
  font-size: 0.98rem;
  user-select: none;
}
.agree-label a {
  color: #2979ff;
  text-decoration: underline;
  margin: 0 2px;
}
.main-btn {
  background: linear-gradient(90deg, #4ba3fa 0%, #2979ff 100%);
  color: #fff;
  border: none;
  border-radius: 16px;
  padding: 13px 0;
  font-size: 1.15rem;
  font-weight: bold;
  margin-top: 10px;
  cursor: pointer;
  transition: background 0.2s, box-shadow 0.2s;
  box-shadow: 0 2px 8px #4ba3fa33;
}
.main-btn:hover {
  background: linear-gradient(90deg, #2979ff 0%, #4ba3fa 100%);
}
.success {
  color: #2979ff;
  font-size: 1rem;
  text-align: center;
  margin-top: 12px;
}
@media (max-width: 600px) {
  .register-root {
    align-items: flex-start;
    padding-left: 24px;
    padding-right: 24px;
    box-sizing: border-box;
    padding-top: 24px;
    padding-bottom: 8px;
  }
  .register-card {
    padding: 18px 16px 10px 16px;
    border-radius: 12px;
    margin: 0 auto;
    max-width: 100%;
    box-sizing: border-box;
  }
  .register-title {
    font-size: 1.35rem;
    margin-bottom: 18px;
    margin-top: 0;
  }
  .register-form {
    gap: 6px;
  }
  .form-group label {
    font-size: 0.98rem;
  }
  .register-form input[type="text"],
  .register-form input[type="tel"],
  .register-form input[type="password"] {
    font-size: 1.05rem;
    padding: 16px 14px;
    border-radius: 12px;
  }
  .ghost-btn {
    font-size: 0.92rem;
    padding: 10px 0;
    border-radius: 12px;
    width: 100%;
    min-width: 100px;
    max-width: 320px;
    margin: 0 auto;
    display: block;
  }
  .main-btn {
    font-size: 1rem;
    padding: 10px 0;
    border-radius: 12px;
    width: 80%;
    min-width: 100px;
    max-width: 320px;
    margin: 16px auto 0 auto;
    display: block;
  }
  .agree-label {
    font-size: 0.92rem;
  }
  .verify-input-group .ghost-btn {
    width: auto;
    min-width: 80px;
    max-width: 140px;
    font-size: 0.92rem;
    padding: 8px 0;
    border-radius: 10px;
    margin: 0;
    display: inline-block;
    align-self: center;
  }
  .checkbox-row {
    flex-direction: column;
    gap: 8px;
  }
  .checkbox-item {
    flex: none;
  }
  .other-input {
    max-width: 100px;
    font-size: 0.85rem;
    padding: 4px 6px;
  }
}
</style> 